export class ActionConstants {
    static readonly EMPTY = '';
    static readonly ADD = 'add';
    static readonly VIEW = 'view';
    static readonly EDIT = 'edit';
    static readonly DELETE = 'delete';
    static readonly REMOVE = 'remove';
    static readonly GET = 'get';
    static readonly UPDATE = 'update';
    static readonly ENABLE = 'enable';
    static readonly DISABLE = 'disable';
    static readonly IMPORT = 'import';
    static readonly LOGS = 'logs';
    static readonly NOTES = 'notes';
    static readonly REVERSE = 'reverse';
    static readonly ACTIVATE = 'Activate';
    static readonly DEACTIVATE = 'Deactivate';
    static readonly VENDOR_EFT_ACCOUNTS = 'vendor-eft-accounts';
    static readonly EXCLUDE_BANK_REC = 'exclude-bank-rec';
    static readonly INCLUDE_BANK_REC = 'include-bank-rec';
    static readonly OPEN_ITEMS = 'open-items';
    static readonly ADD_OPEN_ITEM = 'add-open-item';
    static readonly DIMENSIONS = 'gl-dimensions';
    static readonly MARK_PRIMARY = 'mark-primary';
    static readonly APPLY_CREDITS = 'apply-credits';
    static readonly SPECIAL_HANDLING = 'special-handling';
    static readonly UNLINK_ACCOUNT = 'unlink-account';
    static readonly UNLOCK_ACCOUNT = 'unlock-account';
    static readonly RESET_PASSWORD = 'reset-password';
    static readonly CHANGE_PASSWORD = 'change-password';
    static readonly EXECUTE = 'execute';
    static readonly REPRINT = 'reprint';
    static readonly VOID_PAYMENT = 'void-payment';
    static readonly VOID_AND_REVERSE = 'void-and-reverse';
    static readonly DUPLICATE = 'duplicate';
    static readonly ADD_INVOICE = 'add-invoice';
    static readonly ADD_ADJUSTMENT = 'add-adjustment';
    static readonly ADD_PAYMENT = 'add-payment';
    static readonly WRITE_OFF = 'write-off';
    static readonly ATTACH_RECIEPT = 'attach-reciept';
    static readonly RECLASSIFY = 'reclassify';
    static readonly NON_REIMBURSABLE = 'non-reimbursable';
    static readonly REIMBURSABLE = 'reimbursable';
    static readonly PREPAID_PAYMENT = 'prepaid-payment';
    static readonly CONFIGURATION = 'configuration';
    static readonly EMAIL_ASSIGNED_TO_USERS = 'email-assigned-to-users';
    static readonly UNDELETE = 'undelete';
    static readonly PROCESS = 'process';
    static readonly CLEAR = 'clear';
    static readonly SELECT = 'select';
    static readonly APPROVE = 'approve';
    static readonly UNAPPROVE = 'unapprove';
    static readonly REJECT = 'reject';
    static readonly RESCHEDULE = 'reschedule';
    static readonly CHANGE_ASSIGN_TO = 'change-assign-to';
    static readonly EMAIL_REMINDER = 'email-reminder';
    static readonly APPLICABLE = 'applicable';
    static readonly NOT_APPLICABLE = 'not-applicable';
    static readonly REFRESH = 'refresh';
    static readonly DETAIL = 'detail';
    static readonly MANAGE_USER = 'manage-user';
    static readonly MANAGE_DATA_FIELDS = 'manage-data-fields';
    static readonly CLONE_CUSTOMER_DEFINED_INFO_CONFIG = 'clone-customer-defined-info-config';
    static readonly ASSIGNMENTS = 'assignments';
    static readonly LOCAL_DELETE = 'local-delete';
    static readonly MANAGE_1099_ADDITIONAL_AMOUNT = 'manage-1099-additional-amount';
    static readonly EXPORT = 'export';
    static readonly DENY = 'deny';
    static readonly UPDATE_BILL = 'update-bill';
    static readonly CREATE_BILL = 'create-bill';
    static readonly EDIT_MANAGEMENT_COMPANY = 'edit-management-company';
    static readonly CLEAR_MANAGEMENT_COMPANY = 'clear-management-company';
    static readonly SET_TO_PENDING_APPROVAL = 'set-to-pending-approval';
    static readonly MANAGE_CONTRACTS = 'manage-contracts';
    static readonly TEMPLATE_PREVIEW = 'Preview';
    static readonly TEMPLATE_SELECT = 'Select';
    static readonly LINK_HELP = 'link-help';
    static readonly MOVE = 'Move';
    static readonly END_BILLING = 'End Billing';
}
